// @flow
import React from "react";
import styled from "styled-components";
import { Sentry } from "@nested/isomorphic-sentry";
import { getImage } from "@nested/utils";
import { regularHeading, mediumParagraph } from "@nested/brand";

const Wrapper = styled.div`
  text-align: center;
`;

const Img = styled.img`
  margin-bottom: 20px;
`;

type Props = {
  children: React$Node,
};

type State = {
  hasError: boolean,
};

type ErrorMessageProps = {
  icon: string,
  message: string,
  title: string,
};

const ErrorMessage = ({ icon, title, message }: ErrorMessageProps) => (
  <Wrapper>
    <Img src={getImage(`icons/${icon}`)} />
    <h3 css={regularHeading}>{title}</h3>
    <p css={mediumParagraph}>{message}</p>
  </Wrapper>
);

class ErrorBoundary extends React.Component<Props, State> {
  state = {
    hasError: false,
  };

  componentDidCatch(error: Error, info: any) {
    this.setState({
      hasError: true,
    });
    Sentry.captureException(error, {
      info: JSON.stringify(info),
    });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (!hasError) {
      return children;
    }

    return (
      <ErrorMessage
        icon="error.svg"
        title="Something appears to have gone wrong"
        message="One of our team has been alerted and they'll be working on a fix soon"
      />
    );
  }
}

export { ErrorBoundary };
